<script setup lang="ts">
import { computed } from 'vue';
import { DgrIcon } from '@stockmarkteam/donguri-ui';
import GroupActionButtons from '@/components/group/group-action-buttons.vue';
import Header from '@/components/layouts/header.vue';
import { Group, UserInfo } from '@/types';
import { getTabs } from '@/utils/group';
import { urlParse } from '@/utils/parsers';

interface Props {
  group: Group;
  userInfo: UserInfo;
  isMenuVisible?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isMenuVisible: true,
});

const description = computed(() => {
  const targetGroup = props.group;
  return urlParse(targetGroup.description ?? '');
});
</script>

<template>
  <Header
    :title="group.name"
    :detail="description"
    :tabs="getTabs(group, userInfo)"
    content-width="var(--layout-content-width, 948px)"
    :is-menu-visible="isMenuVisible"
  >
    <template #titleContent>
      <div class="title-content">
        <DgrIcon name="users" />
        {{ group.name }}
      </div>
    </template>
    <template #button>
      <GroupActionButtons :group="group" />
    </template>
  </Header>
</template>
<style scoped lang="scss">
.title-content {
  display: flex;
  gap: 4px;
  align-items: center;
}
</style>
